/* eslint-disable jsx-a11y/accessible-emoji */
import React from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import { connect } from 'react-redux';
import {
    Input, Button, Form, Label
} from 'semantic-ui-react';
import Swal from '#/swal';
import { actions } from './sagaSlice';


const PasswordUpdateForm = props => {

    const { updatePassword } = props;

    const onSubmit = values => {
        delete values.newPasswordConfirmation;
        updatePassword(values);
        Swal.fire(
            'Password Reset Successful!',
            'You will be redirected to the login screen',
            'success'
        );
    };

    return (
        <FinalForm
            validate={validate}
            onSubmit={onSubmit}
            render={({
                handleSubmit, submitting, pristine
            }) => (
                <Form onSubmit={handleSubmit}>
                    <Field name='oldPassword'>
                        {({ input, meta }) => (
                            <Form.Field>
                                <label htmlFor='oldPassword'>Current Password</label>
                                <Input type='password' placeholder='Current Password' {...input}/>
                                {meta.error && meta.touched && <Label basic color='red' pointing>{meta.error}</Label>}
                            </Form.Field>
                        )}
                    </Field>
                    <Field name='newPassword'>
                        {({ input, meta }) => (
                            <Form.Field>
                                <label htmlFor='newPassword'>New Password</label>
                                <Input type='password' placeholder='New Password' {...input}/>
                                {meta.error && meta.touched && <Label basic color='red' pointing>{meta.error}</Label>}
                            </Form.Field>
                        )}
                    </Field>
                    <Field name='newPasswordConfirmation'>
                        {({ input, meta }) => (
                            <Form.Field>
                                <label htmlFor='newPasswordConfirmation'>Confirm New Password</label>
                                <Input type='password' placeholder='Confirm New Password' {...input}/>
                                {meta.error && meta.touched && <Label basic color='red' pointing>{meta.error}</Label>}
                            </Form.Field>
                        )}
                    </Field>

                    <Form.Field>
                        <Button type='submit' disabled={submitting || pristine}>
                            Submit
                        </Button>
                    </Form.Field>
                </Form>
            )}
        />
    );
};

const validate = values => {
    const errors = {};
    if (!values.oldPassword) {
        errors.oldPassword = 'Required';
    }
    if (!values.newPassword) {
        errors.newPassword = 'Required';
    }
    if (!values.newPasswordConfirmation) {
        errors.newPasswordConfirmation = 'Required';
    }
    if (values.newPassword !== values.newPasswordConfirmation) {
        errors.newPasswordConfirmation = 'New password must match password confirmation';
    }

    return errors;
};


export default connect(null, actions)(PasswordUpdateForm);
